import { render } from "./NutricionAgente.vue?vue&type=template&id=19dfa0f1"
import script from "./NutricionAgente.vue?vue&type=script&lang=js"
export * from "./NutricionAgente.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__